export default [{
  path: '/stage/setScheduling',
  name: 'stage-setScheduling',
  title: '设置排班',
  component: () => import('@/views/stage/template/reservationList/template/setScheduling/index')
}];
